import util from "./_util";

const { request } = util;
// let uid=localStorage.getItem("uid")
export default {
  //聊天列表
  queryChatList(params) {
    return request.get("/letter/get_chatlist", params);
  },
  //发送消息
  sendMyPrivateMsg(data) {
    return request.post("/letter/send", data);
  },
  //阅读消息
  readMsg(data) {
    return request.post("/letter/read", data);
  },
  //查询聊天记录
  queryMsgList(params) {
    return request.get("/letter/pager_message_list?receiverid=" + params);
  },
};
